import axios from 'axios';
import { ACCOUNT, BASE_URL, CREATE_CUSTOMER, GETWAY } from './endpoints';

const ACCOUNT_SEARCH = `${BASE_URL}${GETWAY}${ACCOUNT.SEARCH}`;

export const fetchAccountForCustomer = (data: any) => {
    return axios.post(ACCOUNT_SEARCH, data);
};